import { render, staticRenderFns } from "./DiscountVehicleUpdate.vue?vue&type=template&id=c2feea42&"
import script from "./DiscountVehicleUpdate.vue?vue&type=script&lang=js&"
export * from "./DiscountVehicleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports